import React from 'react';
import { Route, Switch, withRouter } from 'react-router';

import TripList from './list/TripList';
import TripDetails from './details/TripDetails';
import ManualAssignments from './list/ManualAssignments';
import TripEscalations from './list/TripEscalations';

class Trips extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/app/trips" exact component={TripList} />
        <Route path="/app/trips/cluster" exact component={TripList} />
        <Route path="/app/trips/part-trips" exact component={TripList} />
        <Route path="/app/trips/part-routes" exact component={TripList} />
        <Route path="/app/trips/manual-assignments" exact component={ManualAssignments} />
        <Route path="/app/trips/escalations" exact component={TripEscalations} />
        <Route path="/app/trips/:id" exact component={TripDetails} />
      </Switch>
    );
  }
}

export default withRouter(Trips);
